module.exports = __webpack_public_path__ + "img/mini-022.b3a8c424.jpg";